import { render, staticRenderFns } from "./FormUpload.vue?vue&type=template&id=19a63b9e&scoped=true&"
import script from "./FormUpload.vue?vue&type=script&lang=tsx&"
export * from "./FormUpload.vue?vue&type=script&lang=tsx&"
import style0 from "./FormUpload.vue?vue&type=style&index=0&id=19a63b9e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a63b9e",
  null
  
)

export default component.exports